<div class="responsive-card d-flex flex-column" [style.gap.rem]="2.5">
  <div class="d-flex flex-column" [style.gap.rem]="2">
    <div class="d-flex gap-3">
      <div class="responsive-card-title flex-grow-1" i18n>Contacts</div>
      <app-tertiary-button
        [size]="BaseButtonSizeEnum.md"
        leftIconSrc="assets/icons/primary/EditIcon.svg"
        (buttonClicked)="editContactsClicked.emit()"
        i18n>
        Edit
      </app-tertiary-button>
    </div>
    <div class="d-flex flex-column gap-4">
      <div class="contacts-card-header" i18n>Primary Contact</div>
      <app-employer-contact-card
        [contact]="primaryContact"
        [isCollapsed]="primaryContactCollapseState"
        (toggle)="primaryContactCollapseState = !primaryContactCollapseState" />
    </div>
  </div>

  <ng-container *ngIf="additionalContacts?.length">
    <div class="d-flex flex-column gap-4">
      <div class="d-flex align-items-center" [style.gap.rem]="2">
        <div class="contacts-card-header" i18n>Additional Contacts</div>
        <div class="d-flex gap-4">
          <button class="no-style-button d-flex gap-2 justify-content-center" (click)="expandAll()">
            <span class="expand-text" i18n>Expand All</span>
            <img class="expand-icon" [src]="'assets/icons/blue/Expand.svg'" alt="" />
          </button>
          <button class="no-style-button d-flex gap-2 justify-content-center" (click)="collapseAll()">
            <span class="expand-text" i18n>Collapse All</span>
            <img class="expand-icon" [src]="'assets/icons/blue/Collapse.svg'" alt="" />
          </button>
        </div>
      </div>
      <app-employer-contact-card
        *ngFor="let contact of additionalContacts"
        [contact]="contact"
        [isCollapsed]="!additionalContactsExpandedState[contact.id]"
        (toggle)="onCardToggle(contact)" />
    </div>
  </ng-container>
</div>
